import { decamelizeKeys } from "humps";
import { sortBy } from "lodash";
import moment from "moment";
import { TEMPLATE_KEYS } from "PFApp/constants/templates";
import { fetchActivities } from "PFCore/services/activities";

export const INTERNAL_EXPERIENCE_ACTIONS = {
  INTERNAL_EXPERIENCE_READY: "INTERNAL_EXPERIENCE_READY",
  INTERNAL_EXPERIENCE_ADD: "INTERNAL_EXPERIENCE_ADD"
};

const processEntries = (entries) => {
  const processedEntries = sortBy(
    entries.map(({ activity }) => {
      ["engagement_hours", "location"].forEach((field) => {
        if (!(field in activity.metadata)) {
          activity.metadata[field] = undefined;
        }
      });
      return activity;
    }),
    (obj) => {
      const dateRange = obj.metadata.date_range || {};
      if (!dateRange.start_date) {
        return Infinity;
      } else if (dateRange.current) {
        return -Infinity;
      } else {
        return -moment(dateRange.start_date);
      }
    }
  );

  return processedEntries;
};

export const internalExperienceReducer = (state, action) => {
  switch (action.type) {
    case INTERNAL_EXPERIENCE_ACTIONS.INTERNAL_EXPERIENCE_READY: {
      return {
        ...state,
        internalExperience: {
          entries: processEntries(action.payload.entries),
          meta: action.payload.meta,
          loaded: true
        }
      };
    }
    case INTERNAL_EXPERIENCE_ACTIONS.INTERNAL_EXPERIENCE_ADD: {
      const newEntries = state.internalExperience.entries.slice(0);
      newEntries.unshift(action.payload);
      const newInternalExperience = {
        entries: processEntries(newEntries),
        meta: { ...state.internalExperience.meta, total: state.internalExperience.meta.total + 1 },
        loaded: true
      };
      return {
        ...state,
        internalExperience: newInternalExperience
      };
    }
  }
};

export const INTERNAL_EXPERIENCE_ASYNC_ACTIONS = {
  FETCH_INTERNAL_EXPERIENCE_LIST: "FETCH_INTERNAL_EXPERIENCE_LIST"
};

export const internalExperienceDispatch = (dispatch, action) => {
  switch (action.type) {
    case INTERNAL_EXPERIENCE_ASYNC_ACTIONS.FETCH_INTERNAL_EXPERIENCE_LIST: {
      fetchActivities({
        per_page: 1000,
        filters: {
          ...action.payload,
          fields: { ...action.payload?.fields, template_key: TEMPLATE_KEYS.WORK }
        }
      }).then((data) => {
        dispatch({
          type: INTERNAL_EXPERIENCE_ACTIONS.INTERNAL_EXPERIENCE_READY,
          payload: decamelizeKeys(data)
        });
      });
    }
  }
};
